import { render, staticRenderFns } from "./withdrawalReview.vue?vue&type=template&id=0a3741b0"
import script from "./withdrawalReview.vue?vue&type=script&lang=js"
export * from "./withdrawalReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports